// components/EventStatusBanner/eventStatus.config.js

export const EVENT_STATUS = {
  PAUSED: "off",
  EXPIRED: "expired",
  DELETED: "deleted",
};

export const STATUS_CONFIG = {
  [EVENT_STATUS.PAUSED]: {
    title: "Evento en pausa",
    description: "La venta de entradas está temporalmente suspendida.",
    backgroundClass: "bg-yellow-500/10",
    textClass: "text-yellow-400",
  },
  [EVENT_STATUS.EXPIRED]: {
    title: "Evento finalizado",
    description: "Este evento ya expiró y no se pueden comprar entradas.",
    backgroundClass: "bg-red-500/10",
    textClass: "text-red-400",
  },
  [EVENT_STATUS.DELETED]: {
    title: "Evento finalizado",
    description: "Este evento ya expiró y no se pueden comprar entradas.",
    backgroundClass: "bg-red-500/10",
    textClass: "text-red-400",
  },
};